import spinLogo from "../../images/PeerEase_icon.png";
import Peerease from "../../images/PeerEase_Logo.png"
type props = {
    timeout?: number,
    type?: any
}

function WHSLoader({ timeout = 3000, type = 'Triangle' }: props) {
    return (
        <div className="loaderContainer">
            {/* <Loader
                type={type}
                color="#556ee6"
                height={80}
                width={80} //3 secs
            /> */}
            <div className="custom-loader"></div>
            <div className='loader-center'>
                <img src={spinLogo} alt="peerease spin" className='logo_spin' />
                <img src={Peerease} alt="peerease logo" />
            </div>
        </div>
    )
};
export default WHSLoader;